export const navigation = {
  links: [
    { label: "Strategy", url: "/strategy/" },
    { label: "Brand Book", url: "/brand-book/", active: true },
    { label: "Communication", url: "/communication/" },
  ],
}
